module.exports = __webpack_public_path__ + "static/img/month_4th-10th_prize.59c479e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prize/month_4th-10th_prize.png
// module id = YtsB
// module chunks = 1